import React from 'react';

interface BrandMarkProps {
  /** Render variant — sidebar (light on dark) or login (dark on light). */
  variant?: 'sidebar' | 'login';
}

const BrandMark: React.FC<BrandMarkProps> = ({ variant = 'sidebar' }) => {
  if (variant === 'login') {
    return (
      <div className="login-brand">
        <div className="brand__mark">
          <img src="/hasaky_icon.png" alt="Hasaky" className="brand__icon" />
        </div>
        <span className="login-brand__name">Hasaky</span>
        <span className="login-brand__sub">Device IOT</span>
      </div>
    );
  }

  return (
    <div className="brand">
      <div className="brand__mark">
        <img src="/hasaky_icon.png" alt="Hasaky" className="brand__icon" />
      </div>
      <div className="brand__text">
        <span className="brand__name">Hasaky</span>
        <span className="brand__tag">Device IOT</span>
      </div>
    </div>
  );
};

export default BrandMark;
